import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

export const getResume = (frmDate,toDate, abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, 
      };    return api.get(`/Profile?Created_Date_Start=${frmDate}&Created_Date_End=${toDate}`, config);
  }

  export const updateResume =(id, data,abortToken )=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.put(`/Profile/${id}`, data, config)
}